import { CommonModule } from '@angular/common';
import { AuditDirectoryCellComponent } from '../../shared/audit/audit-directory-cell.component';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { forkJoin } from 'rxjs';
import { CrmClient } from '../../crm/crm.model';
import { CrmService } from '../../crm/crm.service';
import { statusSeverity, warehousingBreadcrumb, warehousingHomeBreadcrumb } from '../warehousing-common';
import { WarehousingBillingDraft, WarehousingSearchFilters } from '../warehousing.model';
import { WarehousingPageHeaderComponent } from '../warehousing-page-header.component';
import { WarehousingSearchPanelComponent } from '../warehousing-search-panel.component';
import { WarehousingService } from '../warehousing.service';

@Component({
  selector: 'app-warehousing-billing-drafts',
  standalone: true,
  imports: [AuditDirectoryCellComponent,
    CommonModule, ReactiveFormsModule, RouterModule, BreadcrumbModule, ButtonModule, IftaLabelModule,
    InputGroupModule, InputGroupAddonModule, InputTextModule, ProgressBarModule, SelectModule, TableModule,
    TagModule, WarehousingPageHeaderComponent, WarehousingSearchPanelComponent
  ],
  templateUrl: './warehousing-billing-drafts.component.html'
})
export class WarehousingBillingDraftsComponent implements OnInit {
  private fb = inject(FormBuilder);
  private warehousingService = inject(WarehousingService);
  private crmService = inject(CrmService);
  isLoading = false;
  breadcrumbItems: MenuItem[] = warehousingBreadcrumb('Billing Drafts');
  homeBreadcrumb: MenuItem = warehousingHomeBreadcrumb();
  drafts: WarehousingBillingDraft[] = [];
  clients: CrmClient[] = [];
  draftStatusOptions = [
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Posted', value: 'POSTED' },
    { label: 'Cancelled', value: 'CANCELLED' }
  ];

  searchForm = this.fb.group({
    keyword: [''],
    crmClientId: [null as number | null],
    status: [null as string | null],
    billingFrom: [''],
    billingTo: ['']
  });

  ngOnInit(): void { this.loadDrafts(); }

  loadDrafts(): void {
    this.isLoading = true;
    forkJoin({ drafts: this.warehousingService.getBillingDrafts(this.searchFilters()), clients: this.crmService.getClients() }).subscribe({
      next: response => {
        this.drafts = response.drafts.data || [];
        this.clients = response.clients || [];
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  applySearch(): void {
    this.loadDrafts();
  }

  clearSearch(): void {
    this.searchForm.reset({
      keyword: '',
      crmClientId: null,
      status: null,
      billingFrom: '',
      billingTo: ''
    });
    this.loadDrafts();
  }

  clientName(id?: number): string { return this.clients.find(client => client.id === id)?.companyName || '-'; }
  statusSeverity = statusSeverity;

  private searchFilters(): WarehousingSearchFilters {
    return this.searchForm.getRawValue();
  }
}
